export const currencies = [
  { code: 'USD', name: 'US Dollar', symbol: '$' },
];
